module.exports = __webpack_public_path__ + "img/stacked.07216033.png";